var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { createUseStyles } from "react-jss";
var ErrorInner = /** @class */ (function (_super) {
    __extends(ErrorInner, _super);
    function ErrorInner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            error: false,
        };
        return _this;
    }
    ErrorInner.getDerivedStateFromError = function (error) {
        return { error: true };
    };
    ErrorInner.prototype.componentDidCatch = function (error, errorInfo) {
        // TO-DO: Use actual reporting service to catch errors
        console.error(error, errorInfo);
    };
    ErrorInner.prototype.render = function () {
        var classes = this.props.classes;
        if (this.state.error) {
            return (React.createElement("div", { className: classes.root }, "Something went wrong... please try again."));
        }
        return this.props.children;
    };
    return ErrorInner;
}(Component));
var useStyles = createUseStyles({
    root: {
        padding: "10rem 5rem",
        width: "100%",
        textAlign: "center",
        color: "red",
    },
});
var Error = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return React.createElement(ErrorInner, { classes: classes }, children);
};
export default Error;
